import React, { createContext, useContext } from 'react';
import { useTradeSettings } from '../hooks/useTradeSettings';

interface TradingSettings {
  id: number;
  key: string;
  value: string;
}

interface TradeSettingsContextType {
  settings: TradingSettings[] | undefined;
  isLoading: boolean;
  error: Error | null;
}

const TradeSettingsContext = createContext<TradeSettingsContextType | undefined>(undefined);

export function TradeSettingsProvider({ children }: { children: React.ReactNode }) {
  const { data: settings, isLoading, error } = useTradeSettings();

  return (
    <TradeSettingsContext.Provider value={{ settings, isLoading, error }}>
      {children}
    </TradeSettingsContext.Provider>
  );
}

export function useTradeSettingsContext() {
  const context = useContext(TradeSettingsContext);
  if (context === undefined) {
    throw new Error('useTradeSettingsContext must be used within a TradeSettingsProvider');
  }
  return context;
} 